export class ConnectBYOAzureBackupApplicationsRequest {
    'keyVaultAccessServicePrincipalId';
    'managementAppId';
    'managementServicePrincipalId';
    'backupAppId';
    'backupServicePrincipalId';
    'secretUrl';
    'customerTenantId';
    'agentApplicationId';
    'agentServicePrincipalId';
    'agentFederatedManagedIdentityResourceId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "keyVaultAccessServicePrincipalId",
            "baseName": "keyVaultAccessServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "managementAppId",
            "baseName": "managementAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "managementServicePrincipalId",
            "baseName": "managementServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "backupAppId",
            "baseName": "backupAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "backupServicePrincipalId",
            "baseName": "backupServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "secretUrl",
            "baseName": "secretUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "customerTenantId",
            "baseName": "customerTenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "agentApplicationId",
            "baseName": "agentApplicationId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "agentServicePrincipalId",
            "baseName": "agentServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "agentFederatedManagedIdentityResourceId",
            "baseName": "agentFederatedManagedIdentityResourceId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectBYOAzureBackupApplicationsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
